import { render, staticRenderFns } from "./InviteColleague.vue?vue&type=template&id=7cac085c"
import script from "./InviteColleague.vue?vue&type=script&lang=js"
export * from "./InviteColleague.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports